import Query from '../../components/Report';

const query = ({ offset = 0, author = '' }) =>
    new Query('discover-single-author-pages', { offset, author });

export const getAllQuery = ({ author = '' }) =>
    new Query('discover-single-author-pages-all', { author });

export default query;
